export enum CollectionSortTypeEnum {
  RECENT_MODIFIED = 'RECENT_MODIFIED',
  NAME = 'NAME'
}
